// The Reports page's routes (B10 S15; plan D17): `#reports` and `#reports/<family>?<spec>`, shown only to a reader whose
// manifest lists `report.run` (the Interviewer's does not: DC-32 gives the Interviewer no *Reports*). The nav item is
// lit server-side by `backend/app/reporting/nav.py`; App.tsx's V1 NAV row carries the same gate meanwhile.
import { registerView } from "../shell";
import { ReportsPage } from "./ReportsPage";

registerView(/^reports(\/[a-z_]+)?$/, ReportsPage, { lane: "B10", gates: ["report.run"] });
